import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'

import useSeatmapStore from '../../../stores/seatmapStore'

import { UnlockProvider } from '../../PurchaseFlow/NewSeatedPurchaseWrapper/providers/UnlockProvider/UnlockProvider'
import { TicketsProvider } from '../../PurchaseFlow/NewSeatedPurchaseWrapper/providers/TicketsProvider/TicketsProvider'

import SeatmapModal from '../../PurchaseFlow/NewSeatedPurchaseWrapper/providers/SeatmapProvider/SeatmapModal/SeatmapModal'
import { TicketErrorModal } from '../../PurchaseFlow/NewSeatedPurchaseWrapper/providers/CheckoutProvider/TicketErrorModal'
import { PackageSeatmapWrapper } from './PackageSeatmapWrapper'

// Create the context
const PackageSeatmapContext = createContext(undefined)

export const usePackageSeatmap = () => {
  const context = useContext(PackageSeatmapContext)
  if (!context) {
    throw new Error('Context must be used within a PackageSeatmapProvider')
  }
  return context
}

// Provide the functionality for displaying a seatmap inside a modal
export const PackageSeatmapProvider = ({
  eventPackage,
  purchaseLog,
  children,
}) => {
  // Zustand
  const setData = useSeatmapStore((state) => state.setData)
  const setBackground = useSeatmapStore((state) => state.setBackground)
  const setSeatmapId = useSeatmapStore((state) => state.setSeatmapId)
  const resetMapSelection = useSeatmapStore((state) => state.resetMapSelection)

  const dialogRef = useRef(null)
  const errorDialogRef = useRef(null)
  const [seatedError, setSeatedError] = useState(null)
  const [dialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    setData(eventPackage?.seatmap?.mapping)
    setBackground(eventPackage?.seatmap?.background)
    if (eventPackage?.seatmap?.id != null) {
      setSeatmapId(eventPackage.seatmap.id)
    }
  }, [eventPackage, setBackground, setData, setSeatmapId])

  const showSeatmap = () => {
    setDialogOpen(true)
    dialogRef.current.showModal()
  }

  const hideSeatmap = () => {
    confirmCloseMap()
  }

  const confirmCloseMap = () => {
    setDialogOpen(false)
    dialogRef.current.close()

    // Wipe entire selection
    resetMapSelection()
  }

  const modalClose = () => {
    setSeatedError(null)
    errorDialogRef.current.close()
    // Probably just want to refresh here if tickets not available
  }

  useEffect(() => {
    if (seatedError) {
      errorDialogRef.current.showModal()
    }
  }, [seatedError])

  return (
    <PackageSeatmapContext.Provider
      value={{ showSeatmap, eventPackage, purchaseLog, setSeatedError }}
    >
      <TicketsProvider>
        <UnlockProvider>
          <SeatmapModal
            dialogRef={dialogRef}
            hideSeatmap={hideSeatmap}
            title={'Select your seats'}
            dialogOpen={dialogOpen}
            SeatmapWrapper={PackageSeatmapWrapper}
          />
          {/* Change modal */}
          <TicketErrorModal
            dialogRef={errorDialogRef}
            seatedError={seatedError}
            handleClose={modalClose}
          />
          {children}
        </UnlockProvider>
      </TicketsProvider>
    </PackageSeatmapContext.Provider>
  )
}
